import React, { useState } from 'react';
import { Modal, Button, Input, List, message, Space } from 'antd';
import RackLabelsTitle from './RackLabelsTitle';

export default function ShowMergedLinks({ open, data, onCancel, title, loading, onAddLinks }) {
    const [link, setLink] = useState('');
    const [adding, setAdding] = useState(false);

    const addLink = async () => {
        const value = String(link || '').trim();
        if (!value) {
            message.error('Paste a merged guideline link');
            return;
        }
        setAdding(true);
        try {
            await onAddLinks([value]);
            setLink('');
            message.success('Guideline added');
        } catch (err) {
            message.error(err?.response?.data?.message || 'Failed to add guideline');
        } finally {
            setAdding(false);
        }
    };

    return (
        <Modal title={<RackLabelsTitle title={title} mergeIds={data?.mergeIds} />} open={open} onCancel={onCancel} footer={null} width="50%">
            <div style={{ width: '100%', maxHeight: '500px', minHeight: '250px', overflow: 'auto' }}>
                <List
                    itemLayout="horizontal"
                    dataSource={[...(data?.mergeIds || [])]}
                    locale={{ emptyText: 'No guidelines in this session yet' }}
                    renderItem={(item) => (
                        <List.Item>
                            <List.Item.Meta
                                title={<strong>{item?.name}</strong>}
                                description={<p style={{ wordBreak: 'break-all', margin: 0, userSelect: 'none' }}>{item?.link}</p>}
                            />
                        </List.Item>
                    )}
                />
            </div>
            <Space.Compact style={{ width: '100%', marginTop: 12 }}>
                <Input
                    placeholder="Paste merged guideline link"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                    onPressEnter={addLink}
                />
                <Button type="primary" loading={adding || loading} onClick={addLink}>
                    Add guideline
                </Button>
            </Space.Compact>
        </Modal>
    );
}
